import * as React from 'react';
import * as classnames from 'classnames';
import MediaManager from '../../../../../../libraries/mediaLibrary/MediaManager';
import { UilPen, UilImagePlus, UilInfoCircle } from '@iconscout/react-unicons';
import { Notes } from '../../../../../../common/notes';
import { ALERT_MESSAGE_TYPES } from '../../../../../../../interface/project.interface';
import { TEMPLATE_VIDEO_ONLY_BUBBLES } from '../../../../../../../constants/project';
import { getTenantLevel } from '@nexxt/common/firebase/auth/userDetails';
import { TENANT_LEVEL } from '@nexxt/common/types';

interface UploadVideoProps {
    label?: string;
    videoURL: string;
    position?: 'center' | 'left' | 'full';
    disabled?: boolean;
    appyCurrentImage: (data: {
        mediaURL: string;
        label?: string;
        type?: string;
    }) => void;
}

const UploadVideo: React.FC<UploadVideoProps> = ({
    label,
    videoURL,
    position,
    disabled,
    appyCurrentImage
}: UploadVideoProps) => {
    const [showMediaManager, setShowMediaManager] = React.useState(false);
    const tenantLevel = getTenantLevel();

    return (
        <div className="row">
            <div className="col-md-12 form-group-header">
                {label || 'Upload Video'}
            </div>
            {tenantLevel === TENANT_LEVEL.SELF_SERVICE && (
                <div className="col-md-12">
                    <Notes type={ALERT_MESSAGE_TYPES.DANGER}>
                        <div className="note-feature-container">
                            <div className="note-feature-header">
                                <UilInfoCircle size={36} />
                                <span className="note-feature-header-content">
                                    Video
                                    <br />
                                    Requirements
                                </span>
                            </div>
                            <div className="note-feature-body">
                                {TEMPLATE_VIDEO_ONLY_BUBBLES.map(
                                    (bubble, i) => (
                                        <div
                                            className="note-feature-body-item"
                                            key={i}
                                        >
                                            <div className="note-feature-body-item-content">
                                                <span className="note-feature-body-item-content-subtext">
                                                    {bubble.subtext}
                                                </span>
                                                <span>{bubble.text}</span>
                                            </div>
                                        </div>
                                    )
                                )}
                            </div>
                        </div>
                    </Notes>
                </div>
            )}
            <div className="col-md-12 form-group ">
                <div className="media--container">
                    <div
                        className={classnames('media--container', {
                            centered: position === 'center',
                            full: position === 'full'
                        })}
                    >
                        <div className={classnames('media--contents', {})}>
                            <span
                                className={classnames(
                                    'form-group__icon form-group__icon--large',
                                    {
                                        uploaded: !!videoURL,
                                        disabled
                                    }
                                )}
                                onClick={(e) => {
                                    if (!disabled) {
                                        e.stopPropagation();
                                        setShowMediaManager(true);
                                    }
                                }}
                            >
                                <MediaManager
                                    showMediaManager={showMediaManager}
                                    toggleMediaManager={setShowMediaManager}
                                    showMediaLibrary
                                    applyCurrentMedia={appyCurrentImage}
                                    type="video"
                                >
                                    <span></span>
                                </MediaManager>
                                {videoURL ? (
                                    <div
                                        style={{
                                            width: '100%',
                                            height: '100%'
                                        }}
                                    >
                                        <video
                                            key={videoURL}
                                            autoPlay={false}
                                            controls={false}
                                        >
                                            <source
                                                src={videoURL}
                                                type="video/mp4"
                                            />
                                        </video>
                                        <div
                                            className={classnames(
                                                'hover-container',
                                                {
                                                    disabled
                                                }
                                            )}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setShowMediaManager(true);
                                            }}
                                        >
                                            <div
                                                className={classnames(
                                                    'hover-container--item',
                                                    {
                                                        disabled
                                                    }
                                                )}
                                            >
                                                <UilPen size={16} />
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <span>
                                        <UilImagePlus size={40} />
                                    </span>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadVideo;
